import axios from 'axios';

export async function PostDataAPI(methodName, apiData = {}, type = 'POST') {
    let baseUrl = sessionStorage.getItem('server_api_url');
    let token = sessionStorage.getItem('auth_token');

    // Check if the base URL is not set
    if (!baseUrl) {
        console.error("Base URL is not set.");
        return;
    }

    const headers = {
        'Content-Type': 'application/json;charset=utf-8',
        // If you're using authorization, uncomment the following line:
        // 'Authorization': `Bearer ${token}`,
    };

    try {
        // Make the HTTP request using axios
        const response = await axios({
            method: 'POST',
            url: `${baseUrl}${methodName}`,
            data: apiData,
            headers: headers,
        });
        return response.data;  // Return the response data
    } catch (error) {
        console.error("Error in PostDataAPI:", error);
        throw error;  // Re-throw the error so it can be handled in the calling function
    }
}
